import { render, staticRenderFns } from "./SkeletonCarousel.vue?vue&type=template&id=310d825e"
import script from "./SkeletonCarousel.vue?vue&type=script&lang=js"
export * from "./SkeletonCarousel.vue?vue&type=script&lang=js"
import style0 from "./SkeletonCarousel.vue?vue&type=style&index=0&id=310d825e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports